/**
 * Route paths that more than one place has to agree on.
 *
 * Most routes are named once, in MajorRoutes, and nothing else needs to know
 * them. These two are different: a payment provider redirects the browser back
 * to an absolute URL that this app builds, so the URL builder and the router
 * both have to name the same path.
 *
 * They were written out separately and did not match. Checkout sent riders to
 * /payment/success and /payment/cancelled while the router only ever declared
 * /payment-success and /payment-failed, so a completed payment would have
 * returned the rider to a path with no route on it. Nothing caught it because
 * nothing calls checkout yet.
 *
 * Naming them once is the fix. A test would only have caught the instance it
 * was written for; this makes the whole class impossible, because there is no
 * second copy left to drift.
 */
export const routes = {
    /** Where a provider returns the browser after a successful charge. */
    paymentSuccess: "/payment-success",

    /** Failure and cancellation share a page: both mean "not paid". */
    paymentFailed: "/payment-failed",
} as const;

export default routes;
